import { __module as n } from "./ghl-ui.es1642.js";
(function(o, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  function u(t) {
    return function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = r.width ? String(r.width) : t.defaultWidth, d = t.formats[a] || t.formats[t.defaultWidth];
      return d;
    };
  }
  o.exports = e.default;
})(n, n.exports);
var f = n.exports;
export {
  f as b
};
